import { IApplicationState } from '../../types/redux';
import { IPaymentMethod } from '../../types/redux/paymentMethods';

export const selectPaymentMethodById =
  (id: string) =>
  (state: IApplicationState): IPaymentMethod => {
    return state.paymentMethods.methods[id]!;
  };
